var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u590D\u5236") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-287.000000, -1462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u590D\\u5236",
    transform: "translate(287.000000, 1462.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98076923,4.09615385 L2.98076923,5.21153846 C2.36476322,5.21153846 1.86538462,5.71091707 1.86538462,6.32692308 L1.86538462,13.0192308 C1.86538462,13.6352368 2.36476322,14.1346154 2.98076923,14.1346154 L9.67307692,14.1346154 C10.2890829,14.1346154 10.7884615,13.6352368 10.7884615,13.0192308 L11.9038462,13.0192308 C11.9038462,14.2512428 10.9050889,15.25 9.67307692,15.25 L2.98076923,15.25 C1.74875721,15.25 0.75,14.2512428 0.75,13.0192308 L0.75,6.32692308 C0.75,5.09491106 1.74875721,4.09615385 2.98076923,4.09615385 Z M13.0192308,0.75 C14.2512428,0.75 15.25,1.74875721 15.25,2.98076923 L15.25,9.67307692 C15.25,10.9050889 14.2512428,11.9038462 13.0192308,11.9038462 L6.32692308,11.9038462 C5.09491106,11.9038462 4.09615385,10.9050889 4.09615385,9.67307692 L4.09615385,2.98076923 C4.09615385,1.74875721 5.09491106,0.75 6.32692308,0.75 L13.0192308,0.75 Z M13.0192308,1.86538462 L6.32692308,1.86538462 C5.71091707,1.86538462 5.21153846,2.36476322 5.21153846,2.98076923 L5.21153846,9.67307692 C5.21153846,10.2890829 5.71091707,10.7884615 6.32692308,10.7884615 L13.0192308,10.7884615 C13.6352368,10.7884615 14.1346154,10.2890829 14.1346154,9.67307692 L14.1346154,2.98076923 C14.1346154,2.36476322 13.6352368,1.86538462 13.0192308,1.86538462 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#1F70FF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/复制.adda34891edfb3ba96b203d6ab70ad0b.svg";
export { ForwardRef as ReactComponent };